/* eslint-disable import/prefer-default-export */
export const reducerName = `form`;
export const createReducerDotPathName = combineName =>
  `${combineName}.${reducerName}`;
export const createActionName = (combineName, name) =>
  `app/${createReducerDotPathName(combineName)}/${name}`;



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/combines/authUserOutputCashFrom/naming.js